var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAverageHealthWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17159",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17160"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12717",
    d: "M10.978 16.779h0a1.552 1.552 0 012.2 0l2.567 2.574a1.556 1.556 0 01-2.2 2.2l-2.571-2.571a1.552 1.552 0 01.004-2.203z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12722",
    d: "M12.277 20.246l2.169-2.169"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17163"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12717",
    d: "M14.004 16.323h0a1.552 1.552 0 011.556-1.556l3.633.003a1.556 1.556 0 010 3.111l-3.636-.005a1.552 1.552 0 01-1.553-1.553z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12722",
    d: "M17.375 17.856v-3.067"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12720",
    d: "M8.146 20.582H4.54a1.928 1.928 0 01-1.929-1.928V8.536A1.928 1.928 0 014.54 6.607h7.373a1.928 1.928 0 011.928 1.929v3.253",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12721",
    d: "M5.426 2h5.676c1.107 0 1.552.9 1.552 2.005a.765.765 0 01-.765.765H4.562a.764.764 0 01-.765-.765C3.797 2.897 4.319 2 5.426 2z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17164",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 143",
    d: "M8.226 11.595v4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 144",
    d: "M10.226 13.594h-4"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 145",
    strokeLinecap: "round",
    d: "M5.703 4.77v1.389"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 146",
    strokeLinecap: "round",
    d: "M10.75 5.197v.681"
  }))));
}
export default SvgAverageHealthWhite;


//////////////////
// WEBPACK FOOTER
// ./src/icons/averageHealthWhite.svg
// module id = 725
// module chunks = 13